import React, { FC } from 'react';

import { ButtonItem, HeadingItem, MenuGroup, Section } from '@atlaskit/menu';
import EditorSettingsIcon from '@atlaskit/icon/glyph/editor/settings';
import MoreVerticalIcon from '@atlaskit/icon/glyph/more-vertical';

import styled from 'styled-components';

import { ItemListaNotificacoes } from './model/ItemListaNotificacoes';
import { NotificacaoItem, NotificacaoItemPropsEventos } from './NotificacaoItem';
import { H2 } from 'view/component/Tipografia/Texto';
import { Spacing } from 'styles/theme/Tema';
import { PopupBotao } from './util/PopupBotao';
import { SRText } from 'view/component/ScreenReaderText/ScreenReaderText';

export interface NotificacaoListaPropsGeral extends VerTodasProps {
  /**
   * É possível acessar a área das configurações de solicitações?
   */
  showConfiguracoes?: boolean

  /**
   * É possível ver as notificações antigas?
   */
  showVerTodasNotificacoes?: boolean
}

export interface NotificacaoListaProps extends NotificacaoItemPropsEventos, NotificacaoListaPropsGeral {
   /**
   * Lista de notificações
   * 
   * Exibe somente as últimas notificações recebidas
   */
  notificacoes: ItemListaNotificacoes[]
}


export const NotificacaoLista: FC<NotificacaoListaProps> = ({
    notificacoes, onItemClick, onVisualizadoToggle,
    showConfiguracoes=true, showVerTodasNotificacoes=true, onVerTodasNotificacoesClick
  }) => {
  const gerarItem = (notificacao: ItemListaNotificacoes) => <NotificacaoItem key={notificacao.id} notificacao={notificacao} onItemClick={onItemClick} onVisualizadoToggle={onVisualizadoToggle} />;
  
  const notificacoesLidas = notificacoes.filter(it => it.visualizado).map(gerarItem);
  const notificacoesNaoLidas = notificacoes.filter(it => !it.visualizado).map(gerarItem);

  return <MenuGroup maxHeight={350} maxWidth={500}>
    <Section isScrollable>
      <NotificacoesHeader>
        <H2>Notificações</H2>
        { showConfiguracoes && <ConfiguracoesBotao />}
      </NotificacoesHeader>

      <HeadingItem>Novas ({notificacoesNaoLidas.length>0 ? <>{notificacoesNaoLidas.length}<SRText> notificações a ler</SRText></> : <i>Sem notificações</i>})</HeadingItem>
      {notificacoesNaoLidas}

      <HeadingItem>Lidas ({notificacoesLidas.length>0 ? <>{notificacoesLidas.length}<SRText> notificações lidas listadas</SRText></> : <i>Sem notificações</i>})</HeadingItem>
      {notificacoesLidas}
      
    </Section>

    { showVerTodasNotificacoes && <VerTodas onVerTodasNotificacoesClick={onVerTodasNotificacoesClick} />}
  </MenuGroup>
}

const NotificacoesHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: ${Spacing.unit}px;
  padding-left: ${Spacing.unit * 2}px;
`;

const ConfiguracoesBotao: FC = () => {
  const content = () => <ConfiguracoesMenuContexto />
  const trigger = () => <MoreVerticalIcon label="Configurações" />

  return <PopupBotao content={content} trigger={trigger} placement="bottom-end" />
}


const ConfiguracoesMenuContexto: FC = () => {
  return <MenuGroup maxHeight={150}>
    <Section>
      <ButtonItem 
        onClick={() => alert("Ainda não implementado")}
        iconBefore={<EditorSettingsIcon label="Configurações" aria-hidden />}
      >Configurações de notificação</ButtonItem>
    </Section>
  </MenuGroup>
}


interface VerTodasProps {
  /**
   * Evento disparado quando clica no botão de visualizar todas as notificações
   */
  onVerTodasNotificacoesClick?: () => void  
}

const VerTodas: FC<VerTodasProps> = ({onVerTodasNotificacoesClick}) => {
  return <Section hasSeparator>
    <VerTodasComponent>
      <ButtonItem onClick={onVerTodasNotificacoesClick}>Ver todas</ButtonItem>
    </VerTodasComponent>
  </Section>
}

const VerTodasComponent = styled.div`
  span {
    color: ${({theme}) => theme.texto.enfase_media };
    text-align: center;
  }
`;